import React, { useState, useEffect, useRef } from "react";
import { Input, Button, Space, Popconfirm, message } from "antd";
import { ExclamationCircleOutlined, SearchOutlined } from "@ant-design/icons";
import GenericTable from "../../../Components/GenericTable";
import editIcon from "../../../Assets/Icons/editTable.svg";
import delIcon from "../../../Assets/Icons/deleteTable.svg";
import addIcon from "../../../Assets/Icons/add-btn.svg";
import { useNavigate } from "react-router-dom";
import "./style.css";
import { getPlatformKey } from "../../../API/Admin/platformKeys";

const APIAccounts = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const navigate = useNavigate();

  const [platformData, setPlatformData] = useState([]);

  const fetchPlatformApiKeys = async () => {
    try {
      const data = await getPlatformKey();
      const response = data?.data?.platforms;
      setPlatformData(response)
    } catch (error) {
      messageApi.error("Error Fetching Platform Keys")
    }
  }

  useEffect(() => {
    fetchPlatformApiKeys()
  }, [])

  const handleDelete = (key) => {
    setPlatformData((prev) => prev.filter((item) => item.key !== key));
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters, confirm)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : "",
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    setSearchText("");
    confirm();
  };
  const handleClick = () => {
    navigate("/add-api-accounts");
  };
  const viewDetails = (platformKeyId) => {
    navigate(`/view-api-details/${platformKeyId}`);
  };

  const maskValue = (value) => {
    if (!value) return "";

    if (value.length <= 8) {
      return "*".repeat(value.length);
    }

    return `${value.slice(0, 4)}${"*".repeat(5)}${value.slice(-4)}`;
  };

  const platformColumns = [
    {
      title: "Platform",
      dataIndex: "platform_name",
      key: "platform_name",
      ...getColumnSearchProps("platform_name"),
    },
    {
      title: "Configuration Key",
      dataIndex: "key",
      key: "key",
      ...getColumnSearchProps("key"),
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      render: (value) => (
        <span style={{ fontFamily: "monospace" }}>
          {maskValue(value)}
        </span>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      ellipsis: true,
    },
    {
      title: "Last Updated",
      dataIndex: "updated_at",
      key: "updated_at",
      render: (date) =>
        new Date(date).toLocaleString(),
      sorter: (a, b) =>
        new Date(a.updated_at) -
        new Date(b.updated_at),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "13px" }}>
          <a onClick={() => viewDetails(record.id)}>
            <img src={editIcon} alt="Edit" />
          </a>
        </div>
      ),
    },
  ];

  return (
    <div className="api-accounts">
      {/* <div className="button">
        <Button type="default" onClick={handleClick} className="add-btn">
          <img src={addIcon} alt="add user" />
          Add New API Account
        </Button>
      </div> */}
      <div className="table">
        <GenericTable dataSource={platformData} columns={platformColumns} />
      </div>
    </div>
  );
};

export default APIAccounts;
